import { render, staticRenderFns } from "./TestimonialItem.vue?vue&type=template&id=4ec385ce&scoped=true&"
import script from "./TestimonialItem.vue?vue&type=script&lang=ts&"
export * from "./TestimonialItem.vue?vue&type=script&lang=ts&"
import style0 from "./TestimonialItem.vue?vue&type=style&index=0&id=4ec385ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec385ce",
  null
  
)

export default component.exports